module.exports = __webpack_public_path__ + "static/media/videoloadingoverlay.3ef8f0f0.png";